//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vuexMixin from '@/lib/vuexMixin'
import globalMixin from '@/lib/global'

export default {
  mixins: [globalMixin, vuexMixin],
  name: "FooterLayout",
  data() {
    return {
    }
  },
  computed:{
    cnpjInfo(){
      return `${this.companyNameVx} - ${this.cnpjVx}`
    },
    facebook(){
      return this.facebookUrlVx
    },
    youtube(){
      return this.youtubeUrlVx
    },
    linkedin(){
      return this.linkedinUrlVx
    },
    web(){
      return this.siteVx
    },
    instagram(){
      return this.instagramUrlVx
    },
  },
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
    openUrl(url) {
      const httpsString = 'https://'
      if(!url.includes(httpsString) && !url.includes('http')){
        url =httpsString+url
      }
      window.open(url)
    },

    handleClick(url, tabSelection) {
      this.goTo(url)
      this.setRegisterTab(tabSelection)
      this.$vuetify.goTo(0)
    },
    async getAccepetdTermsRequeste(){
      if(this.getToken){
        try {
          const terms = await this.requestEds( "GET",`terms-policies/accepted?types=TERMS&types=POLICY`);
            if(terms && terms.data) {
              this.setTermsPoliciesAccepetd(terms.data)
            }
        } catch (error) {
          console.log(JSON.stringify(error))
        }
      }
    },
    async informAccepetdTermsPolicies(){
      if(this.getToken){
        try {
            await this.requestEds( "GET",`terms-policies/accept?types=TERMS&types=POLICY`);
        } catch (error) {
          console.log(JSON.stringify(error))
        }
      }
    },

  },
}
